// @flow
import type { FormValues } from './types/form';

export const MAILBOX_TYPE_INPUT_NAME: 'type' = 'type';

export const MAILBOX_DURATION_INPUT_NAME: 'duration' = 'duration';
export const MAILBOX_DURATION_ONE_MONTH: '1' = '1';
export const MAILBOX_COUNT_INPUT_NAME: 'count' = 'count';

export const initialFormValuesDefault: FormValues = {
  [MAILBOX_TYPE_INPUT_NAME]: '',
  [MAILBOX_DURATION_INPUT_NAME]: '',
  [MAILBOX_COUNT_INPUT_NAME]: 1,
};
